import cn from "classnames";
import type React from "react";
import { HiBadgeCheck } from "react-icons/hi";
import { VscError } from "react-icons/vsc";
import { formClass } from "../../../../shared/helpers";

interface Word {
	word: string;
	correct: undefined | boolean;
}

interface InputComponentProps {
	index: number;
	onChange: (e: React.ChangeEvent<HTMLInputElement>, index: number) => void;
	value: string;
	words: Word[];
	localIndexRef: React.MutableRefObject<number>;
	prefixClass: string;
}

export const InputComponent: React.FC<InputComponentProps> = ({
	index,
	onChange,
	value,
	words,
	localIndexRef,
	prefixClass,
}) => {
	const correct = words[index]?.correct;

	const showIcon =
		correct !== undefined &&
		(correct ? (
			<HiBadgeCheck
				className={`${cn(formClass(prefixClass, "correct-icon"), {
					[formClass(prefixClass, "correct-icon--active")]: correct,
				})}`}
			/>
		) : (
			<VscError
				className={`${cn(formClass(prefixClass, "incorrect-icon"), {
					[formClass(prefixClass, "incorrect-icon--active")]: !correct,
				})}`}
			/>
		));

	return (
		<div className={formClass(prefixClass, "input-wrapper")}>
			{showIcon}
			<input
				className={cn(formClass(prefixClass, "input"), {
					[formClass(prefixClass, "input--correct")]:
						correct !== undefined && correct,
					[formClass(prefixClass, "input--incorrect")]:
						correct !== undefined && !correct,
				})}
				type="text"
				value={value}
				onChange={(e) => onChange(e, index)}
				onFocus={() => {
					localIndexRef.current = index;
				}}
			/>
		</div>
	);
};
